module.exports = __webpack_public_path__ + "static/img/login_trader_toolbox.e4e87a0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/login_trader_toolbox.svg
// module id = xhEf
// module chunks = 1